import { BrandLogo } from "./BrandLogo";
import { useTranslation } from "react-i18next";

interface OnboardingHeaderProps {
  title?: string;
}

export function OnboardingHeader({ title }: OnboardingHeaderProps = {}) {
  const { t } = useTranslation();
  return (
    <header className="flex h-[72px] w-full shrink-0 items-center justify-between border-b border-[#dddfe4] bg-white px-4 sm:px-6 lg:px-10">
      <BrandLogo compact />
      <p className="text-sm leading-[21px] tracking-[0.07px] text-[#5b616d]">
        {title || t("study.set_up_exam")}
      </p>
    </header>
  );
}
